export default __webpack_public_path__ + "static/media/saxo.d06a289b.png";